import React from 'react';
import "./NewCaseDashboardPage.css"
import DasboardServices from "../Services/DasboardServices";
import Sidebar from "../../components/sidebar/Sidebar";

const NewCaseDashboardPage = () => {


    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <DasboardServices />
                </div>
            </div>
        </div>
    );
};

export default NewCaseDashboardPage;
